import './Home.css';
import React from 'react';
import Typical from 'react-typical'
import { Link } from 'react-router-dom';
import { BsCloudDownload } from 'react-icons/bs';

const steps = [
  ' AHSANUL KABIR', 1000,
  ' WEB DEVELOPER', 1000,
  ' FRONTEND DEVELOPER', 1000,
  ' JAVASCRIPT DEVELOPER', 1000,
]

const Home = () => {
  return (
    <div className="Home">
      <h3 className="text-white">HI THERE !</h3>
      <h1 className="home_title_text">
        <span className="text-white">I'm </span>
        <Typical
          steps={steps}
          loop={Infinity}
          wrapper="span"
        />
      </h1>
      <p className="home_description">
        Hello, my name is Ahsanul Kabir. I’m a web developer. I always use modern technology to develop websites. For the front-end I use React Js, React-Bootstrap, Tailwind CSS and for the back-end I use Node Js, Express Js, MongoDB.
      </p>
      <div>
        <Link to="/about" className="cus_btn">MORE ABOUT ME</Link>
        <a href="https://drive.google.com/u/0/uc?id=1KKya1GeGvmL9CiuZdboOb4lqdBXFUVBo&export=download" className="cus_btn" download>Resume <BsCloudDownload /></a>
      </div>
    </div>
  );
};

export default Home;